<div class="app-tooltip d-flex ">
  <mat-icon *ngIf="text" class="help-tooltip" [tooltip]="HtmlContent" content-type="template" [max-width]="400"
    [hide-delay]="1000">help
  </mat-icon>

  <div class="tooltip-text" [innerHTML]="text"></div>

</div>